export default __webpack_public_path__ + "static/media/preventive-maintenance.26fc381d.png";